export const getDashboardData = {
  pathname: '/api/v4/dashboard',
  method: 'POST',
  headers: {
    'content-type': 'application/json',
  },
  body: options => (options),
}
